import { createSlice } from "@reduxjs/toolkit";
import instance from "../../../api/api.js";

export const fectchProprietesLocationsMaison =
  (payload) => async (dispatch) => {
    dispatch(changeIsLoading(true));
    try {
      console.log("fectchProprietesLocationsMaison", payload);
      const data = {
        annee: !payload.date_debut ? payload : null,
        date_debut: payload.date_debut,
        date_fin: payload.date_fin,
      };
      const response_prevision = await instance.post(
        "previsionProprietesLocation",
        data
      );
      const response_revenu = await instance.post(
        "revenuProprietesLocation",
        data
      );
      const response_recouvrement = await instance.post(
        "recouvrementProprietesLocation",
        data
      );
      const response_data_Indisponible = await instance.post(
        "inactifProprietesLocation",
        data
      );
      console.log(
        "response_data_Indisponible",
        response_data_Indisponible?.data.data
      );
      console.log("response_prevision_dat52", response_prevision);
      response_prevision?.data.data.forEach((element) => {
        response_revenu?.data.data.forEach((item) => {
          if (item.mois === element.mois) {
            item.previsions = element.totalPrevision;
          }
        });
      });
      response_recouvrement?.data.data.forEach((element) => {
        response_revenu?.data.data.forEach((item) => {
          if (item.mois === element.mois) {
            item.recouvrement = element.totalRecouvrement;
          }
        });
      });
      console.log("response_prevision", response_prevision?.data.data);
      console.log("response_revenu2", response_revenu?.data.data);

      const statistiqueData = response_revenu?.data.data.map((item) => {
        return {
          month: item.mois,
          previsions: item.previsions,
          revenus: item.totalRevenu,
          recouvrement: item.recouvrement,
        };
      });
      const statistiqueDataBien = response_prevision?.data.data.map((item) => {
        return {
          month: item.mois,
          maison_location: item.totalBiens,
        };
      });
      const statistiqueDataBienIndisponible =
        response_data_Indisponible?.data.data.map((item) => {
          return {
            month: item.mois,
            maison_location_indisponible: item.totalBiens,
          };
        });
      console.log("statistiqueDataProprieteVenteMaison", statistiqueData);
      dispatch(
        fetch_Statistiques_Prevision_revenus_recouvrement({
          data: statistiqueData,
          dataBien: statistiqueDataBien,
          dataBienIndisponible: statistiqueDataBienIndisponible,
        })
      );
    } catch (error) {
      console.log();
    }
    dispatch(changeIsLoading(false));
  };

export const proprietesLocationsMaisonReducer = createSlice({
  name: "ProprietesLocationsMaison",
  initialState: {
    data: [],
    bien_locations: [],
    biens_location_Indisponible: [],
    isloading: false,
  },
  reducers: {
    fetch_Statistiques_Prevision_revenus_recouvrement: (state, action) => {
      return {
        ...state,
        bien_locations: action.payload.dataBien,
        biens_location_Indisponible: action.payload.dataBienIndisponible,
        data: action.payload.data,
      };
    },
    changeIsLoading: (state, action) => {
      return { ...state, isloading: action.payload };
    },
  },
});

export const {
  fetch_Statistiques_Prevision_revenus_recouvrement,
  changeIsLoading,
} = proprietesLocationsMaisonReducer.actions;
export default proprietesLocationsMaisonReducer.reducer;
